"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebAnalyticsComponent = void 0;
var WebAnalyticsComponent_1 = require("./WebAnalyticsComponent");
Object.defineProperty(exports, "WebAnalyticsComponent", { enumerable: true, get: function () { return WebAnalyticsComponent_1.WebAnalyticsComponent; } });
